define("shared/components/shared/media/filter/filter-date-range", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper u--m__b__sm qa--mediaLib_time_drpdwn">
    <PowerSelect
      @onChange={{@updateDateRange}}
      @options={{this.dateRanges}}
      @renderInPlace={{true}}
      @searchEnabled={{false}}
      @selected={{this.selectedDate}}
      as |date|
    >
      {{date.name}}
    </PowerSelect>
  </div>
  */
  {
    "id": "eBwKT11k",
    "block": "[[[10,0],[14,0,\"o--formWrapper u--m__b__sm qa--mediaLib_time_drpdwn\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@onChange\",\"@options\",\"@renderInPlace\",\"@searchEnabled\",\"@selected\"],[[30,1],[30,0,[\"dateRanges\"]],true,false,[30,0,[\"selectedDate\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,2,[\"name\"]]],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"],[13]],[\"@updateDateRange\",\"date\"],false,[\"power-select\"]]",
    "moduleName": "shared/components/shared/media/filter/filter-date-range.hbs",
    "isStrictMode": false
  });
  let FilterDateRangeComponent = _exports.default = (_class = class FilterDateRangeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _defineProperty(this, "dateRanges", [{
        filter: 'all',
        name: this.intl.t('media_library.filter.date_range.all')
      }, {
        filter: 'week',
        name: this.intl.t('media_library.filter.date_range.week')
      }, {
        filter: 'month',
        name: this.intl.t('media_library.filter.date_range.month')
      }, {
        filter: '3months',
        name: this.intl.t('media_library.filter.date_range.3_months')
      }, {
        filter: '6months',
        name: this.intl.t('media_library.filter.date_range.6_months')
      }]);
    }
    get allDates() {
      return this.args.selectedDateRange === 'all';
    }
    get selectedDate() {
      if (this.allDates) {
        return this.dateRanges[0];
      }
      return this.dateRanges.find(date => date.filter === this.args.selectedDateRange);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FilterDateRangeComponent);
});